<template>
  <VField
    class="mb-6"
    error-class="mt-1"
    :error="validationError"
  >
    <VSelect
      :class="$style['select']"
      :options="options"
      :valid="isValid"
      :invalid="$v.vehicle.$error"
      :optional="optional"
      :loading="loading"
      :disabled="disabled"
      :placeholder="label"
      theme="white"
      v-model="vehicle"
      v-on="$listeners"
      @change="onChange"
    />

    <div
      v-if="networkError"
      slot="error"
      class="absolute text-2xs text-danger-50 mt-1"
    >
      <span>Ha habido un error de conexión. </span>

      <VButton
        theme="link"
        @click="getActivities"
      >
        Reintentar
      </VButton>
    </div>
  </VField>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

import {
  VButton,
  VField,
  VSelect
} from '@c/base'

export default {
  components: {
    VButton,
    VField,
    VSelect
  },

  props: {
    slug: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    optional: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      vehicle: this.value,
      options: {},
      loading: false,
      networkError: false,
      noPlacesAvailable: false
    }
  },

  watch: {
    slug: {
      immediate: true,
      handler: function (newSlug) {
        if (newSlug) {
          this.getActivities()
        }
      }
    },

    value: function (newVal) {
      this.vehicle = newVal
    }
  },

  computed: {
    validationError () {
      if (this.$v.vehicle.$error && !this.$v.vehicle.required) {
        return this.$t('validate.required', { attribute: this.$t('attributes.vehicle') })
      }

      return ''
    },

    isValid () {
      return !this.$v.vehicle.$error &&
             this.$v.vehicle.required
    },

    disabled () {
      return !this.slug ||
             this.loading ||
             this.networkError ||
             this.noPlacesAvailable
    }
  },

  methods: {
    onChange () {
      this.$v.vehicle.$touch()

      this.$emit('input', this.vehicle)
      this.$emit('change', this.vehicle)
    },

    getActivities () {
      this.vehicle = ''
      this.options = {}
      this.networkError = false
      this.loading = true
      this.noPlacesAvailable = false

      this.$emit('placesAvailable', false)

      return axios.get('/api/activities/' + this.slug)
        .then(response => {
          let transformedActivities = this.transformActivities(response.data.data.data)
          this.options = transformedActivities.vehicles

          if (this.options && Object.keys(this.options).length === 0) {
            this.noPlacesAvailable = true

            this.$emit('placesAvailable', true)
          }

          this.$emit('activityListLoaded', transformedActivities.activityList)
        })
        .catch(error => {
          if (!error.status && !error.code) {
            this.networkError = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    transformActivities (activities) {
      let list = {
        activityList: {},
        vehicles: {}
      }

      _.forEach(activities, (activityArray, activityRef) => {
        // Filtra actividades que tienen al menos un lugar disponible (left > 0)
        let filteredActivity = activityArray.filter(activity => activity.left > 0)

        if (filteredActivity.length > 0) {
          // Guarda la lista filtrada de actividades
          list.activityList[activityRef] = filteredActivity

          // Extrae el nombre del vehículo desde action.name del primer workshop disponible
          list.vehicles[activityRef] = filteredActivity[0].action.name
        }
      })

      return list
    }
  },

  validations: {
    vehicle: {
      required
    }
  }
}
</script>

<style lang="scss" module>
.select {
  height: 40px;
}
</style>
